import { UserStatus } from "@/api-schema-enums";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export class UserStatusFilter extends Filter<unknown, unknown> {
  readonly id: string = "userStatuses";
  readonly labelSingular = "common:UserStatus";
  readonly labelPlural = "common:UserStatus";
  readonly placeholder = "common:SelectUserStatus";
  readonly searchPlaceholder = "common:SearchUserStatus";
  readonly emptyText = "common:NoUserStatusFound";

  constructor({ id }: { id?: string } = {}) {
    super();
    if (id) this.id = id;
  }

  getData(): FilterData {
    const options = [
      { id: UserStatus.Enabled, name: "common:Enabled" },
      { id: UserStatus.Disabled, name: "common:Disabled" },
    ];

    return {
      options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
